import { Suspense, type JSX, type ReactNode } from 'react';
import RouteLoader from 'src/components/RouteLoader';

// Helper component for lazy loading with Suspense
const LazyRoute = ({ children }: { children: ReactNode }): JSX.Element => (
    <Suspense fallback={<RouteLoader />}>{children}</Suspense>
);

export default LazyRoute;
